import { type QueryHookOptions, useQuery } from "@apollo/client";
import { AnalyticsViewsByContentQuery } from "../graphql/queries";
import type {
  AnalyticsViewsByContentQueryType,
  AnalyticsViewsByContentQueryVariablesType,
} from "@/types/graphql/partner.generated";

export const useAnalyticsViewsByContentQuery = (
  options?: QueryHookOptions<
    AnalyticsViewsByContentQueryType,
    AnalyticsViewsByContentQueryVariablesType
  >
) => {
  return useQuery<
    AnalyticsViewsByContentQueryType,
    AnalyticsViewsByContentQueryVariablesType
  >(AnalyticsViewsByContentQuery, options);
};
